import { AppBar, Theme, Typography } from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveRole, setRoleOpen } from 'store/slices/userInfoSlice';
import UserInfo from '../../molecules/UserInfo/UserInfo';
import RoleSelect from '../RoleSelect/RoleSelect';
import Language from '../../molecules/Language/Language';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: 'white',
        zIndex: theme.zIndex.drawer + 1,
        position: 'relative',
        minHeight: '60px',
        height: '60px',
        width: '100%',
        boxShadow: 'none',
        borderBottom: '1px solid #ccc',
    },
    toolbar: {
        position: 'relative',
        minHeight: '60px',
        height: '60px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    },

    centered: {
        display: 'flex',
        alignItems: 'center',
    },
    menuButton: {
        color: theme.palette.primary.main,
        marginLeft: theme.spacing(2),
        position: 'absolute',
        left: theme.spacing(1),
    },
    role: {
        marginRight: theme.spacing(2),
        color: '#383b5b',
        cursor: 'pointer',
        fontSize: '18px',
    },
}));

export default ({
    onDrawerToggle,
    userName,
    ...other
}: {
    onDrawerToggle: () => void;
    userName: string;
}) => {
    const classes = useStyles();
    const role = useSelector(getActiveRole);
    const dispatch = useDispatch();

    const handleRoleChange = () => {
        dispatch(setRoleOpen(true));
    };

    return (
        <Box width={1} height={60} boxShadow={0}>
            <AppBar className={classes.root} {...other}>
                <Toolbar className={classes.toolbar}>
                    <Hidden mdUp>
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={onDrawerToggle}
                            className={classes.menuButton}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                    <Typography onClick={handleRoleChange} className={classes.role} variant="body1">
                        {role}
                    </Typography>
                    <UserInfo userName={userName} page="Главная" url="/" />
                    <Language />
                </Toolbar>
            </AppBar>
            <RoleSelect isLogin={false} />
        </Box>
    );
};
